import { parseAsString } from "nuqs/server";

export const customUmrahFlowParams = {
  source: parseAsString.withDefault("").withOptions({ clearOnDefault: true }),
  umrah_city: parseAsString
    .withDefault("")
    .withOptions({ clearOnDefault: true }),
} as const;
